import { useNavigate } from 'react-router-dom';

import { openModalByName } from '@mindtickle/modal/withModal';

import { getModuleFromInitalisedRemote } from '@mindtickle/ui-shell-core/DynamicRemote';

import useCheckRemoteInitialized from '~/components/GlobalHeader/Admin/hooks/useCheckRemoteInitialised';
import { MixpanelEventNameType, MixpanelTrackType } from '~/components/GlobalHeader/Admin/type';
import { DomainInfo } from '~/components/GlobalHeader/Shared/type';

const useSwitchDomainData = ({
  defer,
  onHideDropdownContent,
  track,
  eventName,
  menuKey,
  domain,
}: {
  defer: () => boolean;
  onHideDropdownContent: Function;
  track: MixpanelTrackType<MixpanelEventNameType>;
  eventName: MixpanelEventNameType;
  menuKey: string;
  domain: DomainInfo;
}) => {
  const { isRemoteInitialized } = useCheckRemoteInitialized({ defer });
  const navigate = useNavigate();

  const handleSwitchDomainClick = async () => {
    if (!isRemoteInitialized) return;

    const { remoteName, moduleName } = domain;
    const data = await getModuleFromInitalisedRemote(remoteName, moduleName);
    const MODAL_BY_NAME = data?.[menuKey];

    onHideDropdownContent();
    openModalByName(MODAL_BY_NAME, navigate, { stacking: true });
    track(eventName);
  };

  return { handleSwitchDomainClick, isRemoteInitialized };
};

export default useSwitchDomainData;
